export const BRANDS = [
  {
    title: 'Too Faced',
    name: 'too.faced',
    width: 150,
  },
  {
    title: 'Youth To the People',
    name: 'yttp',
    width: 150,
  },
  {
    title: 'Supergoop',
    name: 'supergoop',
    width: 150,
  },
  {
    title: 'Hourglass',
    name: 'hourglass',
    width: 150,
  },
  {
    title: 'Covergirl',
    name: 'covergirl',
    width: 150,
  },
  {
    title: 'Bioderma',
    name: 'bioderma',
    width: 150,
  },
  {
    title: 'Philosophy',
    name: 'philosophy',
    width: 150,
  },
  {
    title: 'Dr. Denniss Gross',
    name: 'dr.dennus.gross',
    width: 150,
  },
  {
    title: 'NuFace',
    name: 'nuface',
    width: 150,
  },
  {
    title: 'Embryolisse',
    name: 'embryolisse',
    width: 150,
  },
  {
    title: 'PUR',
    name: 'pur',
    width: 100,
  },
  {
    title: 'Tanologist',
    name: 'tanologist',
    width: 150,
  },
  {
    title: 'Wander Beauty',
    name: 'wander.beauty',
    width: 150,
  },
  {
    title: 'Necessaire',
    name: 'necessaire',
    width: 150,
  },
  {
    title: 'Beauty Blender',
    name: 'beautyblender',
    width: 150,
  },
  {
    title: 'Dr Brandt',
    name: 'dr.brandt',
    width: 150,
  },
  {
    title: 'Sweet Chef',
    name: 'sweet.chef',
    width: 120,
  },
  {
    title: 'SLIP',
    name: 'slip',
    width: 100,
  },
  {
    title: 'Shhhowercap',
    name: 'shhhowercap',
    width: 150,
  },
  {
    title: 'Trestique',
    name: 'trestique',
    width: 150,
  },
  {
    title: 'KOVO',
    name: 'kovo',
    width: 140,
  },
  {
    title: 'Tan-Luxe',
    name: 'tan.luxe',
    width: 150,
  },
  {
    title: 'Living Proof',
    name: 'living.proof',
    width: 150,
  },
  {
    title: 'OSEA',
    name: 'osea',
    width: 140,
  },
  {
    title: 'COOLA',
    name: 'coola',
    width: 150,
  },
  {
    title: 'LANEIGE',
    name: 'laneige',
    width: 150,
  },
  {
    title: 'rms beauty',
    name: 'rms',
    width: 120,
  },
  {
    title: 'Kate Somerville',
    name: 'kate.somerville',
    width: 150,
  },
  {
    title: 'Phyto',
    name: 'phyto',
    width: 150,
  },
]
